import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpService} from 'src/app/services/http.service';
import { CheckUserExistsResponse, UserInfoByEmailResponse } from '../models/protest';
import {UtilService} from "./util.service";


@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  constructor(private httpService: HttpService,
              private util: UtilService) {

  }

  validateUser(email: string): Observable<CheckUserExistsResponse> {
    const encodedEmail = this.util.base64UrlEncode(email);
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
            let formData = new HttpParams()
              .set('email', encodedEmail);

            const options = { ...headers};
            const body = { email: encodedEmail };
    return this.httpService.Post('/user/check-if-user-exists/?',body,options);
  }

  getUserByEmail(email: string): Observable<UserInfoByEmailResponse> {
    const encodedEmail = this.util.base64UrlEncode(email);
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    const headersUser = new HttpHeaders({'Content-Type':  'application/json'});
            let formData = new HttpParams()
              .set('email', encodedEmail);

            const optionsUser = { ...headersUser};
            const bodyUser = { email: encodedEmail };
    return this.httpService.Post('/userInfoByEmail/?',bodyUser,optionsUser);
  }



}
